import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import PostComponents from './PostComponents.dump';

const PostMdxProvider: React.FC = ({ children }) => {
	return <MDXProvider components={PostComponents}>{children}</MDXProvider>;
};

export default PostMdxProvider;
